const isoCodes = {
  1: 'EG',
  4: 'SA',
};

export default isoCodes;



// WEBPACK FOOTER //
// ./src/utils/Countries.js